package com.downdogapp

import kotlinx.browser.window

class Timer(private val timeout: Duration,
            private val action: Timer.() -> Unit) {

  private var id: Int = -1

  fun start() {
    id = window.setTimeout(
      handler = {
        action()
        if (id != -1) {
          start()
        }
      },
      timeout = timeout.millis.toInt()
    )
  }

  fun stop() {
    if (id != -1) {
      window.clearTimeout(id)
      id = -1
    }
  }
}
